// extracted by mini-css-extract-plugin
module.exports = {"colors":"'~~css/colors.css'","_jade":"#00c7b2","_white":"#FFFFFF","root":"NewTag_root__1-Zbt"};